import { Button, Input, TextArea } from 'semantic-ui-react';
import { formInput, textArea } from 'src/components/helpers';
import {
  MAX_JOB_POSTINGS,
  jobTitleErrorKey,
} from 'src/containers/comunidad-network/form/networkFormUtils';

const newJobPosting = () => ({
  id: `job-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 8)}`,
  title: '',
  description: '',
});

const NetworkFormJobPostings = ({
  jobPostings = [],
  errorInputs,
  disabled = false,
  onChange,
}) => {
  const postings = Array.isArray(jobPostings) ? jobPostings : [];

  const updatePosting = (id, patch) => {
    onChange(postings.map((posting) => (posting.id === id ? { ...posting, ...patch } : posting)));
  };

  return (
    <section className="form-section">
      <h3 className="form-section__title">Vacantes</h3>
      <div className="form-section__body">
        <p className="job-postings__intro">
          Publica las ofertas de empleo de tu empresa. Cada vacante tiene un título y una
          descripción.
        </p>
        {postings.map((posting, index) => (
          <div className="job-posting" key={posting.id}>
            <div className="job-posting__header">
              <span>Vacante {index + 1}</span>
              <Button
                type="button"
                size="mini"
                basic
                disabled={disabled}
                onClick={() => onChange(postings.filter((item) => item.id !== posting.id))}
              >
                Quitar
              </Button>
            </div>
            {formInput({
              Input,
              disabled,
              handler: (event) => updatePosting(posting.id, { title: event.target.value }),
              label: 'Título de la vacante',
              name: jobTitleErrorKey(posting.id),
              value: posting.title || '',
              errorInputs,
            })}
            {textArea({
              TextArea,
              disabled,
              label: 'Descripción de la vacante',
              name: `jobPostingDescription-${posting.id}`,
              handler: (event) => updatePosting(posting.id, { description: event.target.value }),
              value: posting.description || '',
              errorInputs,
              style: { maxWidth: '100%', minWidth: '100%', width: '100%' },
            })}
          </div>
        ))}
        <Button
          type="button"
          primary
          basic
          disabled={disabled || postings.length >= MAX_JOB_POSTINGS}
          onClick={() => onChange([...postings, newJobPosting()])}
        >
          Agregar vacante
        </Button>
      </div>
    </section>
  );
};

export default NetworkFormJobPostings;
